exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-list .meta-cardInfo[data-v-419a116f] {\n  zoom: 1;\n  margin-top: 16px;\n}\n.app-list .meta-cardInfo > div[data-v-419a116f] {\n  position: relative;\n  text-align: left;\n  float: left;\n  width: 50%;\n}\n.app-list .meta-cardInfo > div p[data-v-419a116f] {\n  line-height: 32px;\n  font-size: 24px;\n  margin: 0;\n}\n.app-list .meta-cardInfo > div p[data-v-419a116f]:first-child {\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 12px;\n  line-height: 20px;\n  margin-bottom: 4px;\n}\n", ""]);

// exports
